module.exports = __webpack_public_path__ + "media/images/countrysquared/it-98784ce8796af8c512d752ca2f90eb12.svg";